import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_END_POINT_DEFINITIONS,
  ADD_END_POINT_DEFINITION,
  UPDATE_END_POINT_DEFINITION,
  DELETE_END_POINT_DEFINITION
} from "./actionTypes"

import {

  getEndPointDefinitionSuccess,
  addEndPointDefinitionSuccess,
  updateEndPointDefinitionSuccess,
  deleteEndPointDefinitionSuccess,
  endPointDefinitionError
  
} from "./actions"

//Include Both Helper File with needed methods
import {

addEndPointDefinition,
updateEndPointDefinition,
deleteEndPointDefinition,
getEndPointDefinitions

} from "../../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';


function* fetchEndPointDefinition() {
  try {
    const response = yield call(getEndPointDefinitions)
    yield put(getEndPointDefinitionSuccess(response))
  } catch (error) {
    yield put(endPointDefinitionError(error))
  }
}

function* onAddEndPointDefinition({ payload: record }) {
  try {
    const response = yield call(addEndPointDefinition, record)
    yield put(addEndPointDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });

  } catch (error) {
    yield put(endPointDefinitionError(error))
  }
}

function* onUpdateEndPointDefinition({ payload: record }) {
  try {
    const response = yield call(updateEndPointDefinition, record)
    yield put(updateEndPointDefinitionSuccess(response))
  } catch (error) {
    yield put(endPointDefinitionError(error))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });

  }
}

function* onDeleteEndPointDefinition({ payload: guid }) {
  try {
    const response = yield call(deleteEndPointDefinition, guid)
    yield put(deleteEndPointDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(endPointDefinitionError(error))
  }
}


function* endPointDefinitionManagementSaga() {

    yield takeEvery(GET_END_POINT_DEFINITIONS,fetchEndPointDefinition)
    yield takeEvery(ADD_END_POINT_DEFINITION,onAddEndPointDefinition)
    yield takeEvery(UPDATE_END_POINT_DEFINITION,onUpdateEndPointDefinition)
    yield takeEvery(DELETE_END_POINT_DEFINITION,onDeleteEndPointDefinition)
}

export default endPointDefinitionManagementSaga
